module.exports = __webpack_public_path__ + "img/spot.198b4f96.png";